// License model 
export default class License {
    constructor (id, license_key, period_id, valid_from, valid_to, approver_id, approved) {
        this.id = id;
        this.license_key = license_key;
        this.period_id = period_id;
        this.valid_from = valid_from;
        this.valid_to = valid_to;
        this.approver_id = approver_id;
        this.approved = approved;     
    }
}